import { useEffect, useState } from 'react'
import { MAX_ZOOM, MIN_ZOOM, SLIDER_MAX, sliderFromZoom, zoomAtCenter, zoomFromSlider, zoomPercent, zoomStep, type ZoomCy } from './zoom'

/** Ce ii trebuie barii din panza: zoom-ul, plus ascultarea lui. */
export type ZoomBarCy = ZoomCy & {
  on: (events: string, handler: () => void) => void
  removeListener: (events: string, handler?: () => void) => void
}

/**
 * Bara de zoom din coltul de jos al hartii: - / sina / + / procentul / Fit /
 * 100%. Sina urmeaza si zoom-ul facut cu rotita sau cu degetele (evenimentul
 * `zoom` al panzei), nu doar pe al ei.
 */
export function ZoomBar({ cy, onFit }: { cy: ZoomBarCy | null; onFit: () => void }) {
  const [level, setLevel] = useState(() => (cy ? cy.zoom() : 1))

  useEffect(() => {
    if (!cy) return
    const sync = () => setLevel(cy.zoom())
    sync()
    cy.on('zoom', sync)
    return () => {
      /* Panza poate fi deja distrusa (re-desenare); dezlegarea nu mai conteaza. */
      try {
        cy.removeListener('zoom', sync)
      } catch {
        /* nimic */
      }
    }
  }, [cy])

  const off = !cy
  return (
    <div className="imap-zoom" id="imapZoom" role="group" aria-label="Zoom">
      <button type="button" className="btn btn-default btn-sm imap-zoom-btn" id="imapZoomOut" title="Zoom out (-)" aria-label="Zoom out" disabled={off || level <= MIN_ZOOM + 1e-6} onClick={() => cy && zoomStep(cy, -1)}>
        <i className="fas fa-minus"></i>
      </button>
      <input
        type="range"
        className="imap-zoom-slider"
        id="imapZoomSlider"
        aria-label="Zoom level"
        aria-valuetext={zoomPercent(level)}
        min={0}
        max={SLIDER_MAX}
        step={1}
        value={sliderFromZoom(level)}
        disabled={off}
        onChange={(e) => cy && zoomAtCenter(cy, zoomFromSlider(Number(e.target.value)))}
      />
      <button type="button" className="btn btn-default btn-sm imap-zoom-btn" id="imapZoomIn" title="Zoom in (+)" aria-label="Zoom in" disabled={off || level >= MAX_ZOOM - 1e-6} onClick={() => cy && zoomStep(cy, 1)}>
        <i className="fas fa-plus"></i>
      </button>
      <span className="imap-zoom-pct" id="imapZoomPct" aria-live="polite">
        {zoomPercent(level)}
      </span>
      <button type="button" className="btn btn-default btn-sm imap-zoom-text" id="imapZoomFit" title="Show the whole map (0)" disabled={off} onClick={onFit}>
        Fit
      </button>
      <button type="button" className="btn btn-default btn-sm imap-zoom-text" id="imapZoom100" title="Actual size" disabled={off} onClick={() => cy && zoomAtCenter(cy, 1)}>
        100%
      </button>
    </div>
  )
}
